import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { Queue } from '../types';

export async function getQueues(): Promise<Queue[]> {
  return apiGet<Queue[]>('/queues');
}

export async function createQueue(data: { name: string; departmentId: string }): Promise<Queue> {
  return apiPost<Queue>('/queues', data);
}

export async function updateQueue(id: string, data: { name?: string; isActive?: boolean }): Promise<Queue> {
  return apiPatch<Queue>(`/queues/${id}`, data);
}

export async function deleteQueue(id: string): Promise<void> {
  return apiDelete<void>(`/queues/${id}`);
}
